import React from 'react';

import { capitalize } from 'lodash/fp';
import { Dot, HandCoins } from 'lucide-react';
import { CiViewTable } from 'react-icons/ci';
import { GiBurningMeteor } from 'react-icons/gi';
import { MdSwapHorizontalCircle } from 'react-icons/md';
import { RiLightbulbLine } from 'react-icons/ri';

import { useMainNavigation } from '@/hooks/useMainNavigation';
import { NavigationLinks, useAdminStore } from '@/shared';
import { cn } from '@/utils';

import { HeaderMenuDrawerSingle } from '../HeaderMenuDrawerComponents';

interface IconProps {
  nav: NavigationLinks;
}

const Icon: React.FC<IconProps> = ({ nav, ...props }) => {
  switch (nav) {
    case NavigationLinks.HISTORY:
      return <CiViewTable {...props} />;
    case NavigationLinks.SWAP:
      return <MdSwapHorizontalCircle {...props} />;
    case NavigationLinks.EARN:
      return <HandCoins {...props} />;
    case NavigationLinks.BURN:
      return <GiBurningMeteor {...props} />;
    case NavigationLinks.PROPOSALS:
      return <RiLightbulbLine {...props} />;
    default:
      return null;
  }
};

interface HeaderMenuDrawerNavigationLinksProps {}

const HeaderMenuDrawerNavigationLinks: React.FC<HeaderMenuDrawerNavigationLinksProps> = () => {
  const { isAdmin } = useAdminStore();
  const { currentNav, onNavChange } = useMainNavigation();

  const navLinks = Object.values(NavigationLinks).filter((nav) => {
    if ([NavigationLinks.EARN, NavigationLinks.BURN, NavigationLinks.PROPOSALS].includes(nav)) {
      return isAdmin;
    }
    return true;
  });

  return (
    <div className="flex flex-col gap-3">
      {navLinks.map((nav) => {
        return (
          <HeaderMenuDrawerSingle
            key={nav}
            Icon={(props) => <Icon nav={nav} {...props} />}
            className={cn(
              'bg-background/60 hover:bg-background/80 cursor-pointer overflow-hidden rounded-xl',
              nav === currentNav && 'bg-background hover:bg-background'
            )}
            onClick={(e) => {
              e.stopPropagation();
              onNavChange(nav);
            }}
          >
            <div className="flex w-full items-center justify-between">
              <span className={cn(nav === currentNav ? 'text-primary' : 'text-muted-foreground')}>
                {capitalize(nav)}
              </span>
              {nav === currentNav && <Dot className="size-4" />}
            </div>
          </HeaderMenuDrawerSingle>
        );
      })}
    </div>
  );
};

export default HeaderMenuDrawerNavigationLinks;
